import React from 'react';
import '../css/IsoDetails.css';

const IsoDetails = () => {
  return (
    <section className="gfi-iso-details-section">
      <div className="gfi-iso-details-container">
        <div className="gfi-iso-details-grid-mesh">
          
          {/* ==========================================
              LEFT COLUMN: HIGH FIDELITY SCAN VIEWER
             ========================================== */}
          <div className="gfi-iso-doc-view-column">
            <div className="gfi-iso-doc-shadow-card">
              <div className="gfi-iso-image-container-frame">
                <img 
                  src="https://images.unsplash.com/photo-1606857521015-7f9fcf423740?q=80&w=800&auto=format&fit=crop" 
                  alt="Official ISO 9001:2015 Certificate - Growth Academy" 
                  className="gfi-iso-scanned-document-file"
                />
              </div>
            </div>
          </div>

          {/* ==========================================
              RIGHT COLUMN: BRANDING CREDENTIAL DATA
             ========================================== */}
          <div className="gfi-iso-content-data-column">
            
            <span className="gfi-iso-qa-badge">QUALITY ASSURANCE</span>
            
            <h2 className="gfi-iso-qa-main-title">Our Commitment to Excellence</h2>
            
            {/* Standard Vector Styled ISO Badge Module Block */}
            <div className="gfi-iso-badge-logo-container">
              <div className="gfi-iso-logo-circle-mesh">
                <span className="gfi-iso-icon-globe">🌐</span>
                <span className="gfi-iso-bold-brand">ISO</span>
              </div>
              <div className="gfi-iso-specification-text">9001:2015</div>
            </div>

            <p className="gfi-iso-qa-narrative-text">
              Growth Academy is proud to be an ISO 9001:2015 certified institution. This 
              international standard for Quality Management Systems (QMS) ensures 
              that we consistently provide services that meet student and regulatory 
              requirements.
            </p>

            {/* Premium Soft Blue Student Impact Value Box matching image 16.JPG */}
            <div className="gfi-iso-student-impact-box">
              <h4 className="gfi-iso-box-header-node">What it means for our students:</h4>
              
              <ul className="gfi-iso-impact-check-list">
                <li>
                  <span className="gfi-iso-check-bullet-glyph">✓</span>
                  <span className="gfi-iso-impact-item-text">High-quality training delivery</span>
                </li>
                <li>
                  <span className="gfi-iso-check-bullet-glyph">✓</span>
                  <span className="gfi-iso-impact-item-text">Standardized academic processes</span>
                </li>
                <li>
                  <span className="gfi-iso-check-bullet-glyph">✓</span>
                  <span className="gfi-iso-impact-item-text">Continuous improvement in curriculum</span>
                </li>
                <li>
                  <span className="gfi-iso-check-bullet-glyph">✓</span>
                  <span className="gfi-iso-impact-item-text">Enhanced student satisfaction</span>
                </li>
              </ul>
            </div>

          </div>

        </div>
      </div>
    </section>
  );
};

export default IsoDetails;